import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const dealPriceAtom = atomWithStorage("deal_price", {
  main_price: 12000,
  discount_type: "",
  discount_amount: 0,
  discount_price: 0,
});

export const paginationAtom = atom({
  limit: 10,
  offset: 0,
  queryType: "",
  total: 0,
});

export const dealDetailsMeetingsAtom = atom([]);

export const dealsAtom = atom([]);
